import { isQuotingToolAvailable } from 'modules/common/permissions';
import { ViewsEntry } from 'modules/views';

import { initRequote } from 'store/routeSagas';

import QuoteDetails from './quoteDetailsPage/entry';

export const quotesBaseRoute = '/quotes';

export default [
  {
    path: `${quotesBaseRoute}/:quoteId/requote`,
    saga: initRequote,
  },
  {
    path: [`${quotesBaseRoute}/create`, `${quotesBaseRoute}/edit/:quoteNumber`],
    component: QuoteDetails,
    helpId: 'quote_details',
    permissions: [isQuotingToolAvailable],
  },
  {
    path: quotesBaseRoute,
    component: ViewsEntry,
    helpId: 'quotes_list',
    permissions: [isQuotingToolAvailable],
  },
];
